import {
  zodCallOffItemPayloadBaseSchema,
  zodCallOffItemResponseSchema,
} from '../validations';

// Request payload schema for updating a call-off item (partial update - all fields optional)
export const zodUpdateCallOffItemPayloadSchema =
  zodCallOffItemPayloadBaseSchema.partial();

// Response schema for updated call-off item (re-export from shared)
export { zodCallOffItemResponseSchema as zodUpdateCallOffItemResponseSchema };
